const WordpressInstruction = () => {
  return (
    <div className="instructions">
       <p>1. Copy the provided code and paste it into the WordPress post, page, or template where you want it to be displayed.</p>
    </div>
  )
}
export default WordpressInstruction